import type { UiSidebarItem } from "@/types/ui";

export function normalizeUiComponentId(
  value: string | null | undefined,
): string | null {
  const path = value?.trim().split(/[?#]/)[0];
  if (!path) return null;

  return path.split("/").filter(Boolean).at(-1) ?? path;
}

export function getUiSidebarItemComponentId(
  item: Pick<UiSidebarItem, "component" | "componentUuid" | "uuid">,
): string {
  return normalizeUiComponentId(item.componentUuid || item.component?.uuid)
    ?? item.uuid;
}

/**
 * The path of the web client this page answers at for a visitor who is not
 * signed in, or an empty string when the page is read inside the account
 * alone. It is the sidebar item that carries it, because the item is what the
 * ecosystem answers publicly beside the components of the page.
 */
export function getUiSidebarItemPublicPath(
  item: Pick<UiSidebarItem, "props">,
): string {
  const value = item.props?.public_path;

  return typeof value === "string" ? value.trim() : "";
}
